var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c(
            "el-select",
            {
              ref: _vm.reference,
              staticClass: "wp-10",
              attrs: {
                filterable: "",
                multiple: "",
                remote: "",
                placeholder: _vm.prop.placeholder
                  ? _vm.prop.placeholder
                  : this.$l10n.__("Rechercher"),
                "remote-method": _vm.remoteMethod,
                loading: _vm.loading
              },
              on: { "remove-tag": _vm.remove },
              model: {
                value: _vm.tmpValue,
                callback: function($$v) {
                  _vm.tmpValue = $$v
                },
                expression: "tmpValue"
              }
            },
            _vm._l(_vm.options, function(item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.fullName, value: parseInt(item.id) }
              })
            }),
            1
          )
        : _c("person-list", { attrs: { list: _vm.options } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }